// Profile
export const contentStep = state => state.contentStep;
export const symbolProfile = state => state.symbolProfile;
export const symbolProfileLoading = state => state.symbolProfileLoading;
export const symbolProfileError = state => state.symbolProfileError;